import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  height: '30px',
  padding: '6px 10px',
  borderColor: themeStyle.varBackgroundAlt,
  backgroundColor: themeStyle.varBackgroundAlt,
  color: themeStyle.varInkMedium,
  iconColor: themeStyle.varInkMedium,
};
